export default __webpack_public_path__ + "static/media/slide7.8d7f697a.jpg";